@use '~/theme/theme' as *;

.popover {
  @include shadow(md);
  @include border-radius(sm);

  background: white;

  &[data-entering] {
    opacity: 0;
    animation: fadein 100ms linear;
  }

  &[data-exiting] {
    opacity: 1;
    animation: fadeout 100ms linear;
  }
}

@keyframes fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
